export default __webpack_public_path__ + "static/media/passanger-carry.7e8b4d1c.png";